// NO usar directamente estos valores. Declararlos a través de config.js.

// Llave sitio web de reCaptcha v2 contratarVessi
export const recaptchaPublicKey = '6LeCJwEaAAAAAKAvTSBmTtvz8700c9O_jl9IjboW';

// Desactivar pago (para emergencias)
export const desactivarPago = false;

// Para advertencia de ambiente no productivo
export const ambienteNoProductivo = false;
